// FILE: src/features/complianceSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import fetchWithAuth from "../utils/fetchWithAuth";

// Fetch compliance summary for all users
export const fetchComplianceSummary = createAsyncThunk(
  "compliance/fetchComplianceSummary",
  async () => {
    // Just the relative path; fetchWithAuth appends the base API URL and token
    const url = "/api/admin/compliance-report/all";
    return await fetchWithAuth(url);
  }
);

// Fetch compliance details for a single user
export const fetchUserCompliance = createAsyncThunk(
  "compliance/fetchUserCompliance",
  async (userId) => {
    const url = `/api/admin/compliance-report/${userId}`;
    return await fetchWithAuth(url);
  }
);

const complianceSlice = createSlice({
  name: "compliance",
  initialState: {
    summary: [],
    userDetails: null,
    loading: false,
    error: null
  },
  reducers: {
    clearUserDetails(state) {
      state.userDetails = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // fetchComplianceSummary
      .addCase(fetchComplianceSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchComplianceSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.summary = action.payload;
      })
      .addCase(fetchComplianceSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // fetchUserCompliance
      .addCase(fetchUserCompliance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserCompliance.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetails = action.payload;
      })
      .addCase(fetchUserCompliance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export const { clearUserDetails } = complianceSlice.actions;
export default complianceSlice.reducer;
